import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../request.js";
import t from "../core/Error.js";
import { isSome as n } from "../core/maybe.js";
import { normalizeMessageBundleLocale as r } from "./messages.js";

function o(_x, _x2, _x3, _x4) {
  return _o.apply(this, arguments);
}

function _o() {
  _o = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, n, o, i) {
    var a, c, l, w, h, u, f;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            a = n.exec(o);

            if (a) {
              _context.next = 3;
              break;
            }

            throw new t("esri-intl:invalid-bundle", "Bundle id \"".concat(o, "\" is not compatible with the pattern \"").concat(n, "\""));

          case 3:
            c = a[1] ? "".concat(a[1], "/") : "", l = a[2], w = r(i), h = "".concat(c).concat(l, ".json"), u = w ? "".concat(c).concat(l, "_").concat(w, ".json") : h;
            _context.prev = 4;
            _context.next = 7;
            return s(e(u));

          case 7:
            f = _context.sent;
            _context.next = 23;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

            if (!(u === h)) {
              _context.next = 14;
              break;
            }

            throw new t("intl:unknown-bundle", "Bundle \"".concat(o, "\" cannot be loaded"), {
              error: _context.t0
            });

          case 14:
            _context.prev = 14;
            _context.next = 17;
            return s(e(h));

          case 17:
            f = _context.sent;
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](14);
            throw new t("intl:unknown-bundle", "Bundle \"".concat(o, "\" cannot be loaded"), {
              error: _context.t1
            });

          case 23:
            return _context.abrupt("return", f);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10], [14, 20]]);
  }));
  return _o.apply(this, arguments);
}

function s(_x5) {
  return _s.apply(this, arguments);
}

function _s() {
  _s = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
    var r;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!n(c.fetchBundleAsset)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", c.fetchBundleAsset(t));

          case 2:
            _context2.next = 4;
            return e(t, {
              responseType: "text"
            });

          case 4:
            r = _context2.sent;
            return _context2.abrupt("return", JSON.parse(r.data));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _s.apply(this, arguments);
}

var i = /*#__PURE__*/function () {
  function i(_ref) {
    var _ref$base = _ref.base,
        e = _ref$base === void 0 ? "" : _ref$base,
        t = _ref.pattern,
        _ref$location = _ref.location,
        n = _ref$location === void 0 ? new URL(window.location.href) : _ref$location;

    _classCallCheck(this, i);

    var r;
    r = "string" == typeof n ? function (e) {
      return new URL(e, new URL(n, window.location.href)).href;
    } : n instanceof URL ? function (e) {
      return new URL(e, n).href;
    } : n, this.pattern = "string" == typeof t ? new RegExp("^".concat(t)) : t, this.getAssetUrl = r, e = e ? e.endsWith("/") ? e : e + "/" : "", this.matcher = new RegExp("^".concat(e, "(?:(.*)/)?(.*)$"));
  }

  _createClass(i, [{
    key: "fetchMessageBundle",
    value: function fetchMessageBundle(e, t) {
      return o(this.getAssetUrl, this.matcher, e, t);
    }
  }]);

  return i;
}();

function a(e) {
  return new i(e);
}

var c = {};
export { i as JSONLoader, a as createJSONLoader, c as test };